import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useInventoryStore } from '../../store/inventoryStore'
import { deleteCategory } from '../../utils/deleteCategory'
import type { ApiError } from '@/types/api'
import { notifyRequestError } from '@/utils/notifyRequestError'

export const useDeleteCategoryMutation = (onSuccess?: () => void) => {
  const removeCategory = useInventoryStore((state) => state.removeCategory)

  return useMutation({
    mutationFn: deleteCategory,
    onSuccess: ({ message, id }) => {
      removeCategory(id)
      toast.success(message || 'Category deleted successfully.')
      onSuccess?.()
    },
    onError: (error: ApiError) => {
      notifyRequestError(error, 'An error occurred while deleting category.')
    },
  })
}
